/** @format */

import { http } from "@/http";

export const deleteSessionLabel = async (
	study: string,
	session: string,
	labels: string[],
): Promise<void> => {
	await http.delete(`studies/${study}/sessions/${session}/labels`, {
		data: labels,
	});
};
